<template>
    <tbody>
        <tr v-if="orderedItems" v-for="row in orderedItems" :class="setCustomClassRow()">
            <td v-if="body.selection && body.selection.active">
                <checkbox @input="callEventSelection($event, row)" :checked="row.selected"></checkbox>
            </td>
            <td v-for="(value, key) in header.list" :class="setCustomClassCell(key)" @click="callEventRow(row)">
                <!-- <span v-if="(body.customCells !== undefined && body.customCells[key] !== undefined) && body.customCells[key](row).text" v-html="body.customCells[key](row).text" @click="body.customCells[key](row).click()"></span> -->
                <span v-if="(body.customCells !== undefined && body.customCells[key] !== undefined && (typeof body.customCells[key](row) == 'string' || typeof body.customCells[key](row) == 'number'))" v-html="body.customCells[key](row)"></span>
                <div v-else-if="(body.customCells !== undefined && body.customCells[key] !== undefined)" :is="body.customCells[key](row).component" :arguments="body.customCells[key](row).arguments"></div>
                <span v-else>{{ row[key] }}</span>
            </td>

            <td v-if="actions.list && actions.list.length > 0">
                <component :is="actionsTemplateSelection" :row="row" :actions="actions"></component>
            </td>
        </tr>
        <tr v-else>
            <td>Loading items ...</td>
        </tr>
    </tbody>
</template>

<script>
export default {
    props: {
        header: Object,
        body: Object,
        rows: Array,
        actions: Object,
        selected: Boolean,
    },
    computed: {
        orderedItems: function () {
            var items = this.rows;

            if (this.header.sort) {
                // TODO :: Replace to invoke API to get result ordered
            }

            return items;
        },
        selectedAll: function() {
            console.log('baseBody selectAll');
            return this.selected ? true : false;
            // for (let row of this.rows) {
            //     this.$set(row, 'selected', this.selected)
            // }
        },
        actionsTemplateSelection: function () {
            var prop = this.actions;
            var path = (prop && prop.template !== undefined && prop.template) ? prop.template : './baseActions';

            if (path === '') {
                return;
            }

            try {
                return require(`${path}`);
            }
            catch (e) {
                console.log('Unable to find (' + path + ') for this automated list');
            }
        },
    },
    methods: {
        callEventSelection: function (event, row) {
            if (this.body.selection.event) {
                this.body.selection.event(event, row);
            }

            // if (event) {
            //     event.stopPropagation();
            // }
        },
        callEventRow: function (row) {
            if (this.body.customRowEvent) {
                this.body.customRowEvent(row);
            }
        },
        setCustomClassRow: function () {
            return (this.body.customRowClass) ? this.body.customRowClass : '';
        },
        setCustomClassCell: function (key) {
            return (this.body.customClassCell) ? this.body.customClassCell[key] : '';
        },
    }
}
</script>



// WEBPACK FOOTER //
// baseBody.vue?9b3b38c6